import { render } from "./Requisitions.vue?vue&type=template&id=2d7ac9e5"
import script from "./Requisitions.vue?vue&type=script&lang=js"
export * from "./Requisitions.vue?vue&type=script&lang=js"

import "./Requisitions.vue?vue&type=style&index=0&id=2d7ac9e5&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__